// extracted by mini-css-extract-plugin
export default {"STResumeFile":"style_STResumeFile__F3kqs","iconFile":"style_iconFile__OGp1V","close":"style_close__niZV3"};